class FounderConsultationWidget {
  constructor() {
    this.selectors = {
      section: '[id="founder-consultancy"]',
      button: '.button--consultation',
      widget: '.calendly-inline-widget'
    };
    
    this.classes = {
      visible: 'is-visible'
    };
    
    this.isInitialized = false;
    this.isOpen = false;
    
    this.init();
  }

  init() {
    try {
      const sections = document.querySelectorAll(this.selectors.section);
      
      if (sections.length === 0) {
        console.warn('FounderConsultationWidget: No founder consultation sections found');
        return;
      }

      sections.forEach((section, index) => {
        this.setupInstance(section, index);
      });

      this.isInitialized = true;
    } catch (error) {
      console.error('FounderConsultationWidget initialization error:', error);
    }
  }

  setupInstance(section, index) {
    const button = section.querySelector(this.selectors.button);
    const widget = section.querySelector(this.selectors.widget);

    if (!button || !widget) {
      console.warn(
        `FounderConsultationWidget: Missing button or widget in section ${index}`
      );
      return;
    }

    if (!widget.parentElement.classList.contains('calendly-widget-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('calendly-widget-wrapper');
      widget.parentElement.insertBefore(wrapper, widget);
      wrapper.appendChild(widget);
    }

    const instanceData = {
      button,
      widget,
      section,
      isOpen: false,
      instanceIndex: index
    };

    this.attachEventListeners(instanceData);

    this.updateButtonAccessibility(button, false);
  }

  attachEventListeners(instanceData) {
    const { button } = instanceData;

    button.removeEventListener('click', this.handleButtonClick.bind(this, instanceData));
    document.removeEventListener('keydown', this.handleEscapeKey.bind(this, instanceData));
    document.removeEventListener('click', this.handleDocumentClick.bind(this, instanceData));

    button.addEventListener('click', this.handleButtonClick.bind(this, instanceData));
    document.addEventListener('keydown', this.handleEscapeKey.bind(this, instanceData));
    document.addEventListener('click', this.handleDocumentClick.bind(this, instanceData));
  }

  handleButtonClick(instanceData, event) {
    event.preventDefault();
    event.stopPropagation();

    const { widget } = instanceData;
    const isCurrentlyOpen = widget.classList.contains(this.classes.visible);

    if (isCurrentlyOpen) {
      this.closeWidget(instanceData);
    } else {
      this.openWidget(instanceData);
    }
  }

  handleEscapeKey(instanceData, event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      const { widget } = instanceData;
      
      if (widget.classList.contains(this.classes.visible)) {
        event.preventDefault();
        this.closeWidget(instanceData);
      }
    }
  }

  handleDocumentClick(instanceData, event) {
    const { widget, button, section } = instanceData;

    const clickedElement = event.target;
    const isClickInSection = section.contains(clickedElement);

    if (!isClickInSection && widget.classList.contains(this.classes.visible)) {
      this.closeWidget(instanceData);
    }
  }

  openWidget(instanceData) {
    const { button, widget, section } = instanceData;

    try {
      widget.classList.add(this.classes.visible);
      this.updateButtonAccessibility(button, true);

      button.setAttribute('aria-expanded', 'true');

      this.smoothScrollToWidget(widget);

      instanceData.isOpen = true;

      this.dispatchCustomEvent('consultationWidgetOpened', section);
    } catch (error) {
      console.error('Error opening widget:', error);
    }
  }

  closeWidget(instanceData) {
    const { button, widget, section } = instanceData;

    try {
      widget.classList.remove(this.classes.visible);

      this.updateButtonAccessibility(button, false);

      button.setAttribute('aria-expanded', 'false');

      instanceData.isOpen = false;

      this.dispatchCustomEvent('consultationWidgetClosed', section);
    } catch (error) {
      console.error('Error closing widget:', error);
    }
  }

  updateButtonAccessibility(button, isOpen) {
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    button.setAttribute('aria-haspopup', 'dialog');
    
    if (!button.hasAttribute('aria-controls')) {
      button.setAttribute('aria-controls', 'calendly-widget-' + Math.random().toString(36).substr(2, 9));
    }
  }

  smoothScrollToWidget(widget) {
    requestAnimationFrame(() => {
      setTimeout(() => {
        const yOffset = -100;
        const elementPosition = widget.getBoundingClientRect().top + window.pageYOffset;
        const scrollPosition = elementPosition + yOffset;

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }, 100);
    });
  }

  dispatchCustomEvent(eventName, target) {
    const event = new CustomEvent(eventName, {
      detail: {
        timestamp: new Date().toISOString()
      }
    });
    target.dispatchEvent(event);
  }

  openWidgetByIndex(instanceIndex) {
    const sections = document.querySelectorAll(this.selectors.section);
    if (sections[instanceIndex]) {
      console.log('Open widget method for future use');
    }
  }

  closeAllWidgets() {
    const widgets = document.querySelectorAll(this.selectors.widget);
    widgets.forEach(widget => {
      widget.classList.remove(this.classes.visible);
    });
  }

  destroy() {
    try {
      const buttons = document.querySelectorAll(this.selectors.button);
      buttons.forEach(button => {
        button.removeEventListener('click', this.handleButtonClick);
      });
      document.removeEventListener('keydown', this.handleEscapeKey);
      document.removeEventListener('click', this.handleDocumentClick);
      this.isInitialized = false;
    } catch (error) {
      console.error('Error destroying widget:', error);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.founderConsultationWidget = new FounderConsultationWidget();
  });
} else {
  window.founderConsultationWidget = new FounderConsultationWidget();
}
